import { render, staticRenderFns } from "./Survey_Reports_blocks.vue?vue&type=template&id=118eaac7&"
import script from "./Survey_Reports_blocks.vue?vue&type=script&lang=js&"
export * from "./Survey_Reports_blocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports